import Image from 'next/image';
import { useState } from 'react';
import logos from '@/components/resultList/images/supplierLogos';
import type { Offer } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';

type SupplierLogoProps = Pick<Offer, 'supplier'> & { className?: string; loading?: 'eager' | 'lazy' };

const SUPPLIER_NAMES = displayValues.suppliers as Record<string, string>;

export const SupplierLogo = ({ supplier, className, loading = 'lazy' }: SupplierLogoProps) => {
    const [failed, setFailed] = useState(false);

    const key = supplier?.toLowerCase();
    const logo = key ? logos()[key] : undefined;
    const showLogo = !!supplier && !!logo && !failed;

    return showLogo ? (
        <Image
            src={logo.src}
            width={logo.width}
            height={logo.height}
            alt={SUPPLIER_NAMES[supplier] ?? supplier}
            className={className}
            priority={loading === 'eager'}
            loading={loading}
            onError={() => setFailed(true)}
        />
    ) : null;
};
